import { getTranslation } from '@utils';

export type TranslateFn = (id: string, params?: { [key: string]: string | number }) => string;

export interface ITranslatable {
	t: TranslateFn;
}

export const Translate = (prefix: string) => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return (target: any) => {
		target.prototype.t = getTranslation(prefix);

		return target;
	};
};
